module.exports = __webpack_public_path__ + "/b940c5d52efce07f8032647abb832662.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/clouds_gmail.svg
 ** module id = 1644
 ** module chunks = 0
 **/